<template>
  <div class="">
    <v-data-table :headers="headers" :items="application" class="elevation-1">
      <template v-slot:item.Amount="{ item }">
        {{ item.Amount | currency }}
      </template>

      <template v-slot:item.ApplicationDateTime="{ item }">
        {{ formatDate(item.ApplicationDateTime) }}
      </template>

      <template v-slot:item.AppliedCategory="{ item }">
        {{ item.AppliedCategory }}
      </template>

      <template v-slot:item.status="{ item }">
        {{
          ["Committee Review", "Verified", "Board Review"].includes(item.status)
            ? "In Review"
            : item.status
        }}
      </template>

      <template v-slot:item.membershipComments="{ item }">
        <v-menu
          offset-x
          v-if="!['New', 'Released', 'Open'].includes(item.status)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              :disabled="item.membershipComments.length === 0"
            >
              <v-icon left>mdi-comment</v-icon>
              Comments
            </v-btn>
          </template>

          <v-card>
            <v-card-subtitle>Reviewer Comments</v-card-subtitle>
            <v-card-text>
              <v-list-item-group>
                <v-list-item
                  two-line
                  v-for="(comment, i) in filterComments(
                    item.membershipComments
                  )"
                  :key="i"
                >
                  <v-list-item-content>
                    <v-list-item-title class="overline">
                      {{ comment.displayName }} -
                      {{
                        formatDate(comment.commentDate, 6)
                      }}</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      comment.comment
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-card-text>
          </v-card>
        </v-menu>
      </template>

      <template v-slot:item.actions="{ item }">
        <div v-if="item.Submitted">
          <v-btn-toggle>
            <v-btn
              :to="{
                name: 'applicationDocument',
                params: { code: encodeRoute(item.Code) },
              }"
              outlined
              v-if="profile.MemberNo === ''"
              small
            >
              <v-icon left small> mdi-file </v-icon>
              File
            </v-btn>

            <!-- certificate -->
            <v-btn
              v-if="
                item.assignedMemberNo &&
                profile.status === 'Active' &&
                profile.MemberShipType !== 'GRADUATE'
              "
              :to="{
                name: 'Certificate',
                params: { code: encodeRoute(item.Code) },
              }"
              outlined
              small
            >
              <v-icon left small> mdi-file </v-icon>
              Certificate
            </v-btn>

            <!-- invoice -->
            <v-btn
              outlined
              small
              color="primary"
              @click="
                $router.push({
                  name: 'invoice',
                  params: { code: encodeRoute(item.Code) },
                })
              "
            >
              <v-icon color="primary" left small> mdi-file </v-icon>
              Invoice
            </v-btn>

            <!-- receipt -->
            <v-btn
              v-if="item.postedReceiptNo"
              outlined
              small
              color="secondary"
              @click="
                $router.push({
                  name: 'receipt',
                  params: { code: encodeRoute(item.postedReceiptNo) },
                })
              "
            >
              <v-icon color="secondary" left small> mdi-file </v-icon>
              Receipt
            </v-btn>

            <!-- rejection letter -->
            <v-btn
              outlined
              small
              v-if="item.status === 'Rejected'"
              color="secondary"
              :to="{
                name: 'RejectionLetter',
                params: { code: encodeRoute(item.Code) },
              }"
            >
              <v-icon color="secondary" left small> mdi-file </v-icon>
              Rejection Letter
            </v-btn>

            <!-- aceptance letter -->
            <v-btn
              outlined
              small
              v-if="item.status === 'Released'"
              color="secondary"
              :to="{
                name: 'AcceptanceLetter',
                params: { code: encodeRoute(item.Code) },
              }"
            >
              <v-icon color="secondary" left small> mdi-file </v-icon>
              Acceptance Letter
            </v-btn>

            <!-- paynow -->
            <v-btn
              v-if="!item.postedReceiptNo"
              outlined
              small
              color="secondary"
              @click="pay(item)"
            >
              Pay Now
              <v-icon color="secondary" right small> mdi-arrow-right </v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>

        <div v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="primary"
                small
                :disabled="!isProfileComplete"
                @click="confirmCertifiedDocument(item)"
              >
                {{ profile.ProfileComplete ? "re-Submit" : "Make Payment" }}
                <v-icon right>mdi-send</v-icon>
              </v-btn>
            </template>
            <span>{{
              isProfileComplete
                ? "Submit your application"
                : "Complete your profile"
            }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <SignaturePadVue
      :dialog="signatureDialog"
      @closeSignatureDialog="canCelSignaturedialog"
      @signatureData="saveSignature"
    />

    <v-dialog v-model="dialog" width="600" persistent>
      <v-card class="pa-7" tile elevation="5">
        <v-card-title> Verify Otp </v-card-title>

        <v-card-text>
          <v-alert
            outlined
            v-if="$store.getters['Application/alert'].status"
            dense
            border="left"
            :type="
              $store.getters['Application/alert'].status === 'success'
                ? 'success'
                : 'error'
            "
            class="mb-10"
          >
            {{ $store.getters["Application/alert"].message }}
          </v-alert>
        </v-card-text>

        <v-form ref="">
          <v-card-text>
            <v-text-field
              dense
              outlined
              label="Otp Code"
              placeholder="Enter Otp code"
              ref="otp_code"
              :rules="rules.required"
              v-model="otp_code"
            />
          </v-card-text>
        </v-form>

        <v-card-actions>
          <v-btn @click="dialog = false" text> Close </v-btn>

          <v-spacer />

          <v-btn @click="VerifyAppOTP" color="primary"> Verify </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Checkout />
  </div>
</template>

<script>
import { appUrl } from "../../../environment/environment";
import DateMixin from "../../../mixins/DateMixin";
import RouterMixin from "../../../router/RouterMixin";
import { AuthService } from "../../auth";
import { EventBus } from "../../../utils/eventBus";
import Checkout from "@kinetics254/paygate/src/views/Checkout.vue";
import SetupMixin from "../../setup/SetupMixin";
import SignaturePadVue from "../../Signature/SignaturePad.vue";

export default {
  name: "ApplicationList",
  mixins: [DateMixin, RouterMixin, SetupMixin],
  components: {
    Checkout,
    SignaturePadVue,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Application No",
          align: "start",
          value: "Code",
        },
        { text: "Applied Category", value: "AppliedCategory" },
        { text: "Amount", value: "Amount" },
        { text: "Application Date", value: "ApplicationDateTime" },
        { text: "Status", value: "status" },
        // { text: "Stage", value: "reviewStage" },
        {
          text: `Feedback from ${process.env.VUE_APP_ORGANIZATION}`,
          value: "membershipComments",
          sortable: false,
        },
        { text: "Actions", align: "center", value: "actions", sortable: false },
      ],
      dialog: false,
      signatureDialog: false,
      otp_code: "",
      applicationData: {},
      signaturePad: null,
      itemToSubmit: {},
    };
  },

  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Application/getApplications");
    });
  },

  mounted() {
    EventBus.$on("application-submitted", () => {
      this.$router.push({
        name: "applicationDocument",
        params: { code: btoa(this.applicationDetails.Code) },
      });
    });
    EventBus.$on("add-signature-success", () => {
      this.signatureDialog = true;
    });
    EventBus.$on("applicationOtp-success", () => {
      this.dialog = true;
    });
    EventBus.$on("applicationverify-success", () => {
      this.dialog = false;
    });
    EventBus.$on("initiate-sendingOTP", () => {
      this.$store.dispatch("Application/sendOTP", {
        userId: AuthService.user.id,
      });
    });

    EventBus.$on(
      "trigger-submit-application-after-comfirming-certified-document",
      () => {
        this.submit(this.itemToSubmit);
      }
    );
  },

  computed: {
    application() {
      return this.$store.getters["Application/applications"];
    },

    applicationDocument() {
      return this.$store.getters["Application/document"];
    },

    checkList() {
      return this.$store.getters["Checklist/checklist"];
    },

    isProfileComplete() {
      let isComplete = true;
      this.$store.getters["Checklist/checklist"].forEach((check) => {
        if (!check.pass && check.mandatory) isComplete = false;
      });

      return isComplete;
    },

    profile() {
      return AuthService.user.profile;
    },
    user() {
      return AuthService.user;
    },
    member() {
      return !this.is_admin
        ? AuthService.user.profile.memberInformation.shift()
        : null;
    },
    rules() {
      return {
        required: [(v) => !!v || "Field is required"],
      };
    },
  },

  methods: {
    canCelSignaturedialog(val) {
      this.signatureDialog = val;
    },
    saveSignature(data) {
      this.$store.dispatch("Signature/saveSignature", {
        namespace: "Application",
        base64Attachment: data,
        profileID: this.user.profile_id,
      });
    },
    filterComments(comments) {
      return comments.filter((comment) => !comment.hiddenFromApplicant);
    },
    pay: function (data) {
      const PhoneNo =
        this.profile.PhoneNo.charAt(0) === "+"
          ? this.profile.PhoneNo.slice(1)
          : this.profile.PhoneNo.charAt(0) === "0"
          ? `254${this.profile.PhoneNo.slice(1)}`
          : this.profile.PhoneNo;

      let payload = {
        payerID: data.ProfileID,
        sourceDocumentNo: data.Code,
        transactionCode: data.transactionCode,
        serviceID: data.serviceRequestCode,
        description: "Application Payment",
        amount: data.Amount,
        accountNo: PhoneNo,
        email: this.profile.Email,
        idNumber: this.profile.IdentificationDocumentNo,
        name: `${this.profile.FirstName} ${this.profile.LastName}`,
        success_url: new URL(
          this.$router.resolve({ name: "ApplicationList" }).href,
          appUrl
        ),
        fail_url: window.location.href,
      };
      console.log("payload: ", JSON.stringify(payload));

      payload = btoa(
        JSON.stringify(payload).replace(
          /[\u0100-\uffff]/g,
          (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, "0")}`
        )
      );
      // window.location.href = new URL(`?payload=${payload}`, payGateUrl);
      this.$checkout.pay(payload);
    },
    confirmCertifiedDocument(item) {
      this.itemToSubmit = item;
      this.$confirm.show({
        title: "Confirm Certified Documents Uploaded",
        text: "By clicking Continue, you confirm that all the documents uploaded in this application are certified by commissioner of oaths",
        rejectLabel: "Cancel",
        acceptLabel: "Continue",
        onConfirm: () => {
          const payload = {
            ProfileID: this.profile.ProfileID,
            confirmed: true,
          };
          this.$store.dispatch("Profile/updateProfile", payload);
        },
      });
    },
    submit(item) {
      this.itemToSubmit = {};
      this.$confirm.show({
        title: `Submit Application ?`,
        text: `By clicking submit, you confirm that you have read the terms and conditions, that you understand them and that you agree to be bound by them.`,
        rejectLabel: "Cancel",
        acceptLabel: "Submit",
        onConfirm: () => {
          this.applicationData = { ...item };
          // const data = {
          //   userId: this.user.id,
          // };
          this.$store.dispatch("Signature/submitandSetSignaturePad", {
            namespace: "Application",
          });
          // this.$store.dispatch("Application/submit", { ...item });
          // this.$store.dispatch(
          //   "Application/getApplicationsDocument",
          //   item.Code
          // );
          this.applicationDetails = item;
        },
      });
    },
    VerifyAppOTP() {
      const data = {
        otp_code: { otp_code: this.otp_code },
        appData: { ...this.applicationData },
      };
      this.$store.dispatch("Application/verifySubmitOtp", data);
      this.applicationDetails = this.applicationData;
    },
    getDescription(code) {
      const member = this.membershipCategories.filter(
        (item) => item.Code === code
      )[0];
      return member ? member.Description : "";
    },
  },
};
</script>

<style scoped>
canvas {
  display: block;
  border: 0.1em solid black;
  background-color: white;
  width: 5em;
  height: 2em;
  width: 24vw;
  height: 14vw;
  border-radius: 10px;
  margin: 0 auto;
}
</style>
